import { Amplify } from 'aws-amplify';

export default awsCognitoConfig => Amplify.configure(awsCognitoConfig);
